// Deep-link do modal "Baixe o aplicativo" (ENG-495): `?open=modal-aplicativo`.
// Mesmo desenho dos outros `?open=` do layout (roleta, promocode, check-in): o
// layout reconhece o valor, manda a store abrir e limpa a URL.
export const APP_DOWNLOAD_QUERY_VALUES = ['modal-aplicativo'];

export function isAppDownloadOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return typeof first === 'string' && APP_DOWNLOAD_QUERY_VALUES.includes(first);
}

// Deep-link do cartaz do bônus app-only (ENG-799): `?open=modal-bonus-app`.
// Valor separado, e não mais uma grafia do de cima, porque são dois cartazes
// diferentes: este é o convite do bônus resgatável só pelo app.
export const APP_DOWNLOAD_BONUS_QUERY_VALUES = ['modal-bonus-app'];

export function isAppDownloadBonusOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return (
    typeof first === 'string' && APP_DOWNLOAD_BONUS_QUERY_VALUES.includes(first)
  );
}

// Lojas oficiais. Fixas aqui (e não no LINK_TO_APP_DOWNLOAD do appearance) porque
// o modal precisa das DUAS — o appearance só carrega um link, o do popup PWA.
//
// A Play aponta para o PACOTE, não para uma busca (ENG-843). O app React Native
// herdou o applicationId do antigo TWA, então quem ainda roda o TWA está numa
// versão velha do MESMO aplicativo: ele não precisa instalar, precisa atualizar.
// O link direto abre a ficha já mostrando "Atualizar"; a busca o obrigaria a
// procurar e não deixaria isso claro. É o mesmo link já usado no rodapé.
export const APP_STORE_LINKS = {
  googlePlay:
    'https://play.google.com/store/apps/details?id=br.bet.apostatudo.twa',
  appStore: 'https://apps.apple.com/br/app/apostatudo/id6773755738',
} as const;
